<ng-container *ngIf="handsetService.isXs; else desktopMenu">
  <button mat-icon-button (click)="mobileMenuClicked($event)">
    <app-icon  [color]="'#575481'"  name="more_horiz" [size]="20"></app-icon>
  </button>

  <div class="mobile-container" [hidden]="!visible" (click)="stopPropagation($event)">
    <div class="mobile-menu">
      <div class="header">
        <div class="logo">
          <app-notifications-biller-logo [billerCodes]="notification.biller"></app-notifications-biller-logo>
        </div>
        <div class="title">
          <div class="flex flex-col">
            <div class="bold granat-text">{{ notification.title }}</div>
            <div class="f-12 pb-6 violet-text">{{ notification.content }}</div>
          </div>
          <button mat-icon-button (click)="changeVisibility()">
            <app-icon name="clear" [size]="20"></app-icon>
          </button>
        </div>
      </div>

      <div class="actions">
        <ng-container [ngTemplateOutlet]="menuActions"></ng-container>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #desktopMenu>
  <mat-menu #menu="matMenu">
    <ng-container [ngTemplateOutlet]="menuActions"></ng-container>
  </mat-menu>

  <button mat-icon-button [matMenuTriggerFor]="menu" (click)="stopPropagation($event)" >
    <app-icon [color]="'#575481'" name="more_horiz"></app-icon>
  </button>
</ng-template>

<ng-template #menuActions>
  <button
    mat-menu-item
    *ngIf="notification.status === NotificationStatus.READ"
    (click)="markAs(NotificationStatus.UNREAD)">
    <div fxFlex fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm=" center">
      <app-icon name="notifications_active" color="rgba(0, 0, 0, 0.7)"
                [ngStyle.lt-sm]="{'margin-right': 0}"></app-icon>
      <span fxFlex.lt-sm="100%" [ngStyle.lt-sm]="{'text-align': 'center'}">
    Oznacz jako nieprzeczytane
  </span>
    </div>
  </button>
  <button
    mat-menu-item
    *ngIf="notification.status === NotificationStatus.UNREAD"
    (click)="markAs(NotificationStatus.READ)"
  >
    <div fxFlex fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm=" center">
      <app-icon name="notifications_active" color="rgba(0, 0, 0, 0.7)"
                [ngStyle.lt-sm]="{'margin-right': 0}"></app-icon>
      <span fxFlex.lt-sm="100%" [ngStyle.lt-sm]="{'text-align': 'center'}">
    Oznacz jako przeczytane
  </span>
    </div>

  </button>
  <button mat-menu-item (click)="markAs(NotificationStatus.REMOVED)">
    <div fxFlex fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm=" center">
      <app-icon name="delete" color="rgba(0, 0, 0, 0.7)" [ngStyle.lt-sm]="{'margin-right': 0}"></app-icon>
      <span fxFlex.lt-sm="100%" [ngStyle.lt-sm]="{'text-align': 'center'}">
      Usuń
    </span>
    </div>
  </button>
  <button mat-menu-item (click)="redirectToSettings()">
    <div fxFlex fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm=" center">
      <app-icon name="settings_outlined" color="rgba(0, 0, 0, 0.7)"
                [ngStyle.lt-sm]="{'margin-right': 0}"></app-icon>
      <span fxFlex.lt-sm="100%" [ngStyle.lt-sm]="{'text-align': 'center'}">
      Ustawienia powiadomień
    </span>
    </div>
  </button>
</ng-template>
